export default function redirectTo(user) {
    // let roles = []
    // if (user) {
    //     roles = user.adm_roles.map(item => item.name)
    // }

    window.location.href = 'dashboard'

    // if (roles.some(item => item === 'administrator')) {
    //     window.location.href = 'saques'
    // }
    // if (roles.some(item => item === 'financial')) {
    //     window.location.href = 'saques'
    // }
    // if (roles.some(item => item === 'compliance')) {
    //     window.location.href = 'clientes'
    // }
    // if (roles.some(item => item === 'risk')) {
    //     window.location.href = 'clientes'
    // }
    // if (roles.some(item => item === 'attendance')) {
    //     window.location.href = 'clientes'
    // }
}